import clsx from "clsx";
import React, { FC } from "react";

interface Props {
    style?: React.CSSProperties;
    className?: string;
    render?: () => React.ReactNode;
    text?: string;
}

const Empty: FC<Props> = (props) => {
    const { render, text = "no data", className } = props;
    const cls = clsx(
        "iconfont icon-meiyoushuju flex h-[2.0833rem] flex-col items-center justify-center text-[0.4167rem] text-[#999]",
        className
    );
    return (
        <div className={cls}>
            {render ? render() : <span className={"text-[0.12rem]"}>{text}</span>}
        </div>
    );
};
export default Empty;
